module.exports = __webpack_public_path__ + "static/media/favorite.bb9e9ae0.svg";